export const DONE_BUTTON_TEXT = "Done";
export const DESKTOP_CALENDAR_TITLE =
  "Select your pick-up and drop-off dates for your car rental";
